import { render, staticRenderFns } from "./roleTab.vue?vue&type=template&id=668c71ec&scoped=true&"
import script from "./roleTab.vue?vue&type=script&lang=js&"
export * from "./roleTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c71ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668c71ec')) {
      api.createRecord('668c71ec', component.options)
    } else {
      api.reload('668c71ec', component.options)
    }
    module.hot.accept("./roleTab.vue?vue&type=template&id=668c71ec&scoped=true&", function () {
      api.rerender('668c71ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/role/roleTab.vue"
export default component.exports